import React, { useEffect, useState } from 'react';
import './Preparationexpedition.css';
import Graph4 from '../components/Graph4';
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

const Preparationexpedition = () => {

    useEffect(() => {
    document.title = 'MYSSA – Préparation';
  }, []);


  const [data, setData] = useState([]);
  const [pickingLog, setPickingLog] = useState([]);
  const [filteredPickingLog, setFilteredPickingLog] = useState([]);
  const [selectedCommande, setSelectedCommande] = useState(null);

  const hiddenColumns = ['ID', 'Client_id'];

  const [selectedHorizon, setSelectedHorizon] = useState(null);

  // --------------------
  // Export Excel
  // --------------------
const exportToExcel = () => {
  if (!displayedPickingLog || displayedPickingLog.length === 0) return;

  const today = new Date();
  const dateStr = `${String(today.getDate()).padStart(2,'0')}/${String(today.getMonth()+1).padStart(2,'0')}/${today.getFullYear()}`;

  const firstRow = displayedPickingLog[0];
  const numCommande = firstRow['Commande client'] || '';
  const client      = firstRow['Client'] || '';

  // Colonnes source à exclure de l'affichage
  const excludedCols = [...hiddenColumns, 'Client', 'Stock', 'Rupture', 'Horizon'];

  // Colonnes finales dans l'ordre voulu
  const sourceCols = Object.keys(firstRow).filter(k => !excludedCols.includes(k));
  const finalCols  = [...sourceCols, 'Qté préparée', 'Manquant'];

  const nbLignes = displayedPickingLog.length;

  const aoa = [
    // Ligne 0 — titre
    [`PICKING LIST  —  Commande : ${numCommande}  -  ${client}  -  ${dateStr}`],
    // Ligne 1 — sous-infos
    [`Client : ${client}`, '', `Date : ${dateStr}`, '', `Nb lignes : ${nbLignes}`],
    // Ligne 2 — vide
    [],
    // Ligne 3 — en-têtes (RAL → Qté commandé)
    finalCols.map(c => c === 'RAL' ? 'Qté commandé' : c),
    // Lignes données
    ...displayedPickingLog.map(row =>
      finalCols.map(c => {
        if (c === 'Qté préparée') return '';   // colonne vide à remplir manuellement
        if (c === 'Manquant')     return '';   // colonne vide à remplir manuellement
        return row[c] ?? '';
      })
    ),
     [],   // ligne vide
  [],   // ligne vide
  [],   // ligne vide
  ['Préparateur :', '', 'Nom : _______________________', '', '', 'Signature : _______________________'],
  [],
  ['Date de préparation :', '', '_______ / _______ / _______'],

  ];

  
  const ws = XLSX.utils.aoa_to_sheet(aoa);

  // Fusion titre
  ws['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: finalCols.length - 1 } },
  ];

  // Largeurs colonnes
  ws['!cols'] = finalCols.map(c =>
    c === 'Description'     ? { wch: 36 } :
    c === 'Emplacement'     ? { wch: 22 } :
    c === 'Commande client' ? { wch: 18 } :
    c === 'RAL'             ? { wch: 14 } :
    c === 'Qté préparée'    ? { wch: 14 } :
    c === 'Manquant'        ? { wch: 13 } :
    c.toLowerCase().includes('date') ? { wch: 14 } :
    { wch: 13 }
  );

  // Hauteurs lignes
  ws['!rows'] = [
    { hpt: 28 },
    { hpt: 16 },
    { hpt: 6  },
    { hpt: 18 },
  ];

  // Style titre
  const titleCell = ws['A1'];
  if (titleCell) {
    titleCell.s = {
      font:      { bold: true, sz: 14, color: { rgb: 'FFFFFF' } },
      fill:      { fgColor: { rgb: '04202D' } },
      alignment: { horizontal: 'center', vertical: 'center' },
    };
  }

  // Style sous-infos
  ['A2', 'C2', 'E2'].forEach(addr => {
    if (ws[addr]) {
      ws[addr].s = {
        font:      { bold: true, sz: 10, color: { rgb: '04202D' } },
        fill:      { fgColor: { rgb: 'E8F4FD' } },
        alignment: { horizontal: 'left', vertical: 'center' },
      };
    }
  });

  // Style en-têtes
  finalCols.forEach((_, ci) => {
    const addr = XLSX.utils.encode_cell({ r: 3, c: ci });
    if (ws[addr]) {
      ws[addr].s = {
        font:      { bold: true, sz: 10, color: { rgb: 'FFFFFF' } },
        fill:      { fgColor: { rgb: '1E3A5F' } },
        alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
        border:    { bottom: { style: 'medium', color: { rgb: '38BDF8' } } },
      };
    }
  });

  // Style colonnes "à remplir" (Qté préparée + Manquant) — fond légèrement coloré
  const qtePrepIndex = finalCols.indexOf('Qté préparée');
  const manquantIndex = finalCols.indexOf('Manquant');

  // Style lignes données
  displayedPickingLog.forEach((row, ri) => {
    const excelRow = 4 + ri;
    const isEven   = ri % 2 === 0;
    const bgFill   = isEven ? { fgColor: { rgb: 'FFFFFF' } } : { fgColor: { rgb: 'F5F8FC' } };

    finalCols.forEach((col, ci) => {
      const addr = XLSX.utils.encode_cell({ r: excelRow, c: ci });
      if (!ws[addr]) ws[addr] = { t: 's', v: '' };

      let fill = bgFill;
      let font = { sz: 10 };
      let border = {
        bottom: { style: 'thin', color: { rgb: 'E2E8F0' } },
        right:  { style: 'thin', color: { rgb: 'E2E8F0' } },
      };

      // Colonnes à remplir manuellement → fond crème
      if (ci === qtePrepIndex || ci === manquantIndex) {
        fill  = { fgColor: { rgb: 'FFFBEB' } };
        border = {
          ...border,
          left:  { style: 'thin', color: { rgb: 'FCD34D' } },
          right: { style: 'thin', color: { rgb: 'FCD34D' } },
        };
      }

      // Horizon
 

      ws[addr].s = {
        fill,
        font,
        border,
        alignment: {
          horizontal: 'center',
          vertical: 'center',
          wrapText: col === 'Emplacement',
        },
      };
    });
  });

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Picking List');

  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  const filename = selectedCommande
    ? `Picking_List_${numCommande}_${dateStr.replace(/\//g, '-')}.xlsx`
    : `Picking_List_${dateStr.replace(/\//g, '-')}.xlsx`;
  saveAs(blob, filename);
};

  // --------------------
  // Chargement données
  // --------------------
  useEffect(() => {
    fetch(`${API}/plan_expedition_cmde_client`)
      .then(response => response.json())
      .then(data => {
        const filteredData = data.map(item => ({
          Horizon: item.Horizon,
          'Nbre de commande': item['Nbre de commande'],
          'Nbre de ligne': item['Nbre de ligne'],
        }));
        setData(filteredData);
      })
      .catch(error => console.error('Erreur plan_expedition_cmde_client:', error));
  }, []);

  useEffect(() => {
    fetch(`${API}/picking_log`)
      .then(response => response.json())
      .then(data => {
        const filteredData = data.filter(
          item => item && item['Date de livraison prevue'] && item['Horizon'] !== 'J++'
        );
        const formattedData = filteredData.map(item => {
          let formattedDate = '';
          if (item['Date de livraison prevue']) {
            const d = new Date(item['Date de livraison prevue']);
            if (!isNaN(d)) formattedDate = d.toLocaleDateString('fr-FR');
          }
          return { ...item, 'Date de livraison prevue': formattedDate };
        });
        setPickingLog(formattedData);
        setFilteredPickingLog([]);
        setSelectedCommande(null);
      })
      .catch(error => console.error('Erreur picking_log:', error));
  }, []);

  // --------------------
  // Handlers
  // --------------------
const handleHorizonClick = (horizonValue) => {
  const filteredData = pickingLog.filter(item => item.Horizon === horizonValue);
  const uniqueCommandes = [...new Set(filteredData.map(item => item['Commande client']))];
  setFilteredPickingLog(uniqueCommandes);
  setSelectedCommande(null);
  setSelectedHorizon(horizonValue);  // ← ajouter
};

  const handleCommandeClick = (commande) => {
    setSelectedCommande(commande);
  };

const displayedPickingLog = selectedCommande
  ? pickingLog.filter(item =>
      item['Commande client'] === selectedCommande &&
      item.Horizon === selectedHorizon              // ← filtre ajouté
    )
  : pickingLog;

  // --------------------
  // Badge Horizon
  // --------------------
  const renderHorizonBadge = (value) => {
    const base = {
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: '6px',
      fontFamily: "'IBM Plex Mono', monospace",
      fontSize: '10px',
      fontWeight: '500',
    };
    const styles = {
      Retard: { backgroundColor: '#fee2e2', color: '#b91c1c' },
      J:      { backgroundColor: '#fef9c3', color: '#92400e' },
    };
    const s = styles[value] || { backgroundColor: '#dcfce7', color: '#15803d' };
    return <span style={{ ...base, ...s }}>{value}</span>;
  };

  return (
    <div className="graph-container1">
      <Graph4 width="700px" height="500px" />

      {/* Tableau 1 — Horizon */}
      <div className="table-container12">

        {/* Bandeau titre */}
        <div style={{ position: 'absolute', top: '-10px', left: '-50px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ width: '3px', height: '18px', background: 'linear-gradient(180deg, #04202d, #38bdf8)', borderRadius: '2px' }} />
          <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: '20px', fontWeight: '200', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#04202d' }}>
            Préparation
          </span>
        </div>
        <table>
          <thead>
            <tr>
              <th>Horizon</th>
              <th>Nbre de commande</th>
              <th>Nbre de ligne</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td onClick={() => handleHorizonClick(item.Horizon)} className="clickable">
                  {renderHorizonBadge(item.Horizon)}
                </td>
                <td>{item['Nbre de commande']}</td>
                <td>{item['Nbre de ligne']}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Tableau 2 — Commandes filtrées */}
      <div className="table-container-picking-log">
        <table>
          <thead>
            <tr>
              <th>Cdes restantes à préparer</th>
            </tr>
          </thead>
          <tbody>
            {filteredPickingLog.map((commande, index) => {
        const lignesCommande = pickingLog.filter(
  item => item['Commande client'] === commande && item.Horizon === selectedHorizon
);
              const totalRupture = lignesCommande.reduce(
                (sum, item) => sum + Number(item.Rupture || 0), 0
              );
              const bgColor = totalRupture === 0
                ? { backgroundColor: '#dcfce7', color: '#15803d' }
                : { backgroundColor: '#fee2e2', color: '#b91c1c' };

              return (
                <tr key={index}>
                  <td
                    onClick={() => handleCommandeClick(commande)}
                    className="clickable"
                    style={{
                      ...bgColor,
                      fontFamily: "'IBM Plex Mono', monospace",
                      fontSize: '11px',
                      fontWeight: '500',
                    }}
                  >
                    {commande}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <button className="export-buttonpicking" onClick={exportToExcel}>
          Exporter la picking list {selectedCommande ? selectedCommande : ''}
        </button>
      </div>

      {/* Tableau 3 — Picking log complet */}
      <div className="table-container-full-picking-log">
        <table>
          <thead>
            {displayedPickingLog[0] && (
              <tr>
                {Object.keys(displayedPickingLog[0])
                  .filter(key => !hiddenColumns.includes(key))
                  .map((key, index) => (
                    <th key={index}>{key}</th>
                  ))}
              </tr>
            )}
          </thead>
          <tbody>
            {displayedPickingLog.map((item, rowIndex) => (
              <tr key={rowIndex}>
                {Object.keys(item)
                  .filter(key => !hiddenColumns.includes(key))
                  .map((key, colIndex) => {
                    let cellStyle = {};

                    if (key === 'Rupture' && Number(item[key]) !== 0) {
                      cellStyle.backgroundColor = '#fee2e2';
                      cellStyle.color = '#b91c1c';
                    }

                    if (key === 'Emplacement' && item[key] === 'pas de stock') {
                      cellStyle.backgroundColor = '#fee2e2';
                      cellStyle.color = '#b91c1c';
                    }

                    if (key === 'Emplacement') {
                      cellStyle.whiteSpace = 'pre-line';
                    }

                    if (key === 'Horizon') {
                      return (
                        <td key={colIndex}>
                          {renderHorizonBadge(item[key])}
                        </td>
                      );
                    }

                    return (
                      <td key={colIndex} style={cellStyle}>
                        {item[key]}
                      </td>
                    );
                  })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
};

export default Preparationexpedition;